import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";

class AppointmentDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appointment: null,
      isLoad: true,
      loading: false,
      branches: {},
    }
  }

  componentDidMount() {
    this.getAppointmentInfo();
  }

  getAppointmentInfo = async () => {
    const appointmentID = this.props.match.params.id;
    try {
      const response = await apiCall(`business/appointment/${appointmentID}`, 'get', null);
      if (response && response.data) {
        this.setState({ appointment: response.data, isLoad: false });
      } else {
        this.setState({ isLoad: false });
        Swal.fire({
          title: 'Hata',
          text: 'Randevu bulunamadı',
          icon: 'error',
          confirmButtonText: 'Tamam'
        }).then(() => {
          this.props.history.push(`${process.env.PUBLIC_URL}/appointments`);
        });
      }
    } catch (error) {
      this.setState({ isLoad: false });
      Swal.fire({
        title: 'Hata',
        text: 'Randevu bilgileri yüklenirken bir hata oluştu',
        icon: 'error',
        confirmButtonText: 'Tamam'
      }).then(() => {
        this.props.history.push(`${process.env.PUBLIC_URL}/appointments`);
      });
    }
  }

  getBranches = async () => {
    try {
      const response = await apiCall('business/branches/get-branches', 'get', null);
      const branches = {};
      if (response && Array.isArray(response)) {
        response.forEach(branch => {
          branches[branch.id] = branch.name;
        });
      } else if (response && response.data && Array.isArray(response.data)) {
        response.data.forEach(branch => {
          branches[branch.id] = branch.name;
        });
      }
      return branches;
    } catch (error) {
      Swal.fire('Hata', 'Şubeler yüklenirken bir hata oluştu', 'error');
      return {};
    }
  }

  handleApprove = async () => {
    const { appointment } = this.state;
    if (!appointment) return;

    // Şubeler yüklenirken loader göster
    Swal.fire({
      title: 'Şubeler yükleniyor...',
      text: 'Lütfen bekleyin',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      // Şubeleri çek
      const branches = await this.getBranches();

      // Loader'ı kapat
      Swal.close();

      // Şube seçimi için modal aç
      const { value: branchId } = await Swal.fire({
        title: 'Şube Seçin',
        input: 'select',
        inputOptions: branches,
        inputPlaceholder: 'Şube seçin',
        showCancelButton: true,
        confirmButtonText: 'Onayla',
        cancelButtonText: 'İptal',
        inputValidator: (value) => {
          if (!value) {
            return 'Lütfen bir şube seçin';
          }
        }
      });

      if (!branchId) {
        return;
      }

      // Servis notu için input
      const { value: serviceNotes } = await Swal.fire({
        title: 'Servis Notu (Opsiyonel)',
        input: 'textarea',
        inputPlaceholder: 'Servis notu giriniz...',
        showCancelButton: true,
        confirmButtonText: 'Onayla',
        cancelButtonText: 'İptal',
        inputAttributes: {
          'aria-label': 'Servis notu'
        },
        allowOutsideClick: false
      });

      const result = await Swal.fire({
        title: 'Randevuyu onaylamak istediğinize emin misiniz?',
        text: "Bu işlem araç kaydını servise atayacak ve servis kaydı oluşturacak.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Evet, onayla!',
        cancelButtonText: 'Hayır, iptal et',
        preConfirm: async () => {
          const confirmButton = Swal.getConfirmButton();
          const originalButtonText = confirmButton.innerHTML;
          confirmButton.disabled = true;
          confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

          try {
            await apiCall(`business/appointment/${appointment.id}/approve`, 'post', {
              branch_id: branchId,
              service_notes: serviceNotes || ''
            });
            return true;
          } catch (error) {
            return false;
          } finally {
            confirmButton.innerHTML = originalButtonText;
            confirmButton.disabled = false;
          }
        }
      });

      if (result.isConfirmed) {
        if (result.value) {
          Swal.fire(
            'Onaylandı!',
            'Randevu onaylandı ve servis kaydı oluşturuldu.',
            'success'
          ).then(() => {
            this.getAppointmentInfo();
          });
        } else {
          Swal.fire(
            'Hata!',
            'Randevu onaylanırken bir hata oluştu.',
            'error'
          );
        }
      }
    } catch (error) {
      // Hata durumunda loader'ı kapat
      Swal.close();
      Swal.fire({
        title: 'Hata!',
        text: 'Şubeler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      return;
    }
  }

  handleReject = async () => {
    const { appointment } = this.state;
    if (!appointment) return;

    const { value: rejectionReason } = await Swal.fire({
      title: 'Red Nedeni',
      input: 'textarea',
      inputPlaceholder: 'Red nedeni giriniz...',
      showCancelButton: true,
      confirmButtonText: 'Reddet',
      cancelButtonText: 'İptal',
      inputValidator: (value) => {
        if (!value || value.trim().length === 0) {
          return 'Lütfen red nedeni giriniz';
        }
      },
      allowOutsideClick: false
    });

    if (!rejectionReason) {
      return;
    }

    const result = await Swal.fire({
      title: 'Randevuyu reddetmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Evet, reddet!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall(`business/appointment/${appointment.id}/reject`, 'post', {
            rejection_reason: rejectionReason
          });
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'Reddedildi!',
          'Randevu reddedildi.',
          'success'
        ).then(() => {
          this.getAppointmentInfo();
        });
      } else {
        Swal.fire(
          'Hata!',
          'Randevu reddedilirken bir hata oluştu.',
          'error'
        );
      }
    }
  }

  handleCancel = async () => {
    const { appointment } = this.state;
    if (!appointment) return;

    const { value: cancellationReason } = await Swal.fire({
      title: 'İptal Nedeni',
      input: 'textarea',
      inputPlaceholder: 'İptal nedeni giriniz...',
      showCancelButton: true,
      confirmButtonText: 'İptal Et',
      cancelButtonText: 'Vazgeç',
      inputValidator: (value) => {
        if (!value || value.trim().length === 0) {
          return 'Lütfen iptal nedeni giriniz';
        }
      },
      allowOutsideClick: false
    });

    if (!cancellationReason) {
      return;
    }

    const result = await Swal.fire({
      title: 'Randevuyu iptal etmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Evet, iptal et!',
      cancelButtonText: 'Hayır, vazgeç',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall(`business/appointment/${appointment.id}/cancel`, 'post', {
            cancellation_reason: cancellationReason
          });
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'İptal Edildi!',
          'Randevu iptal edildi.',
          'success'
        ).then(() => {
          this.getAppointmentInfo();
        });
      } else {
        Swal.fire(
          'Hata!',
          'Randevu iptal edilirken bir hata oluştu.',
          'error'
        );
      }
    }
  }

  getStatusBadge = (status) => {
    const statusMap = {
      'pending': { text: 'Beklemede', class: 'badge-warning' },
      'approved': { text: 'Onaylandı', class: 'badge-success' },
      'rejected': { text: 'Reddedildi', class: 'badge-danger' },
      'cancelled': { text: 'İptal Edildi', class: 'badge-secondary' },
      'completed': { text: 'Tamamlandı', class: 'badge-info' }
    };
    const statusInfo = statusMap[status] || { text: status, class: 'badge-secondary' };
    return `<span class="badge ${statusInfo.class}">${statusInfo.text}</span>`;
  }

  render() {
    const {appointment, isLoad, loading} = this.state;
    const {userPermissions} = this.props;
    const canApprove = userPermissions && (userPermissions.includes('approve appointment') || userPermissions.includes('approve_appointment'));

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Randevu Detayı"
              Breadcrumb={[
                {name: "Randevular", navigate: "appointments"},
                {name: "Detay", navigate: ""},
              ]}
            />
            {appointment && (
              <>
                {/* Status Badge - Üstte */}
                <div className="row clearfix">
                  <div className="col-lg-12 col-md-12">
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '15px 20px',
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      marginBottom: '20px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                      <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                        <span className="badge" style={{
                          backgroundColor: this.getStatusColor(appointment.status),
                          color: '#fff',
                          fontSize: '14px',
                          padding: '8px 16px',
                          borderRadius: '20px',
                          fontWeight: '600'
                        }}>
                          <i className={`icon-${this.getStatusIcon(appointment.status)}`} style={{marginRight: '6px'}}></i>
                          {this.getStatusText(appointment.status)}
                        </span>
                        <span style={{color: '#666', fontSize: '14px'}}>
                          Randevu #{appointment.id}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Main Information Card */}
                <div className="row clearfix">
                  <div className="col-lg-12 col-md-12">
                    <div className="card">
                      <div className="header">
                        <h2>
                          <i className="icon-info"></i> Randevu Detayları
                        </h2>
                      </div>
                      <div className="body">
                        <div className="row">
                          {/* Servis Bilgileri */}
                          {appointment.service && (
                            <div className="col-lg-6 col-md-12" style={{marginBottom: '20px'}}>
                              <h6 style={{color: '#666', marginBottom: '15px', fontWeight: '600'}}>
                                <i className="icon-build text-purple"></i> Servis Bilgileri
                              </h6>
                              <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px'}}>
                                {appointment.service.logo_url ? (
                                  <div style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '8px',
                                    border: '1px solid #e0e0e0',
                                    overflow: 'hidden'
                                  }}>
                                    <img 
                                      src={appointment.service.logo_url} 
                                      alt={appointment.service.name || 'Servis'}
                                      style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain'
                                      }}
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                      }}
                                    />
                                    <div style={{
                                      display: 'none',
                                      width: '100%',
                                      height: '100%',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: '#fff'
                                    }}>
                                      <i className="icon-build" style={{fontSize: '24px', color: '#999'}}></i>
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #e0e0e0'
                                  }}>
                                    <i className="icon-build" style={{fontSize: '24px', color: '#999'}}></i>
                                  </div>
                                )}
                                <div>
                                  <div style={{fontWeight: '600', color: '#333', fontSize: '16px'}}>
                                    {appointment.service.name || '-'}
                                  </div>
                                  {appointment.service.phone && (
                                    <div style={{color: '#666', fontSize: '14px', marginTop: '4px'}}>
                                      <i className="icon-phone" style={{marginRight: '4px'}}></i>
                                      {appointment.service.phone}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          
                          <div className="col-lg-6 col-md-12">
                            <h6 style={{color: '#666', marginBottom: '15px', fontWeight: '600'}}>
                              <i className="icon-info text-cyan"></i> Araç Bilgileri
                            </h6>
                            <table className="table table-borderless">
                              <tbody>
                                <tr>
                                  <td style={{width: '40%', fontWeight: '600', color: '#666'}}>
                                    <i className="icon-directions_car text-cyan"></i> Plaka:
                                  </td>
                                  <td>{appointment.vehicle?.plate?.toUpperCase() || '-'}</td>
                                </tr>
                                <tr>
                                  <td style={{width: '40%', fontWeight: '600', color: '#666'}}>
                                    <i className="icon-local_offer text-orange"></i> Marka / Model:
                                  </td>
                                  <td>
                                    {`${appointment.vehicle?.brand?.name || ''} ${appointment.vehicle?.model?.name || ''}`.trim() || '-'}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{width: '40%', fontWeight: '600', color: '#666'}}>
                                    <i className="icon-person text-green"></i> Müşteri:
                                  </td>
                                  <td>
                                    {`${appointment.vehicle?.customer?.name?.toUpperCase() || ''} ${appointment.vehicle?.customer?.surname?.toUpperCase() || ''}`.trim() || '-'}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <h6 style={{color: '#666', marginBottom: '15px', fontWeight: '600'}}>
                              <i className="icon-event text-blue"></i> Randevu Detayları
                            </h6>
                            <table className="table table-borderless">
                              <tbody>
                                <tr>
                                  <td style={{width: '40%', fontWeight: '600', color: '#666'}}>
                                    <i className="icon-calendar text-blue"></i> Randevu Tarihi:
                                  </td>
                                  <td>
                                    {appointment.appointment_date && appointment.appointment_time
                                      ? `${mainHelper.dateOnlyFormat(appointment.appointment_date)} ${appointment.appointment_time}`
                                      : '-'}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{width: '40%', fontWeight: '600', color: '#666'}}>
                                    <i className={`icon-${appointment.is_emergency ? 'warning text-red' : 'check_circle text-grey'}`}></i> Acil Durum:
                                  </td>
                                  <td>
                                    <span className={`badge ${appointment.is_emergency ? 'badge-danger' : 'badge-secondary'}`}>
                                      {appointment.is_emergency ? 'Evet' : 'Hayır'}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* Action Buttons - Sağ Alta */}
                        {appointment.status === 'pending' && canApprove && (
                          <div className="row mt-4">
                            <div className="col-lg-12">
                              <div style={{display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '10px'}}>
                                <button
                                  type="button"
                                  className="btn btn-success waves-effect"
                                  onClick={this.handleApprove}
                                  disabled={loading}
                                  style={{minWidth: '120px'}}
                                >
                                  <i className="icon-check"></i> Onayla
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger waves-effect"
                                  onClick={this.handleReject}
                                  disabled={loading}
                                  style={{minWidth: '120px'}}
                                >
                                  <i className="icon-close"></i> Reddet
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Notes Section */}
                {(appointment.description || appointment.customer_notes || appointment.service_notes || appointment.rejection_reason) && (
                  <div className="row clearfix">
                    <div className="col-lg-12 col-md-12">
                      <div className="card">
                        <div className="header">
                          <h2>
                            <i className="icon-note"></i> Notlar ve Açıklamalar
                          </h2>
                        </div>
                        <div className="body">
                          {appointment.description && (
                            <div className="alert alert-info">
                              <strong><i className="icon-info"></i> Açıklama:</strong>
                              <p className="mb-0 mt-2">{appointment.description}</p>
                            </div>
                          )}
                          {appointment.customer_notes && (
                            <div className="alert alert-warning">
                              <strong><i className="icon-person"></i> Müşteri Notları:</strong>
                              <p className="mb-0 mt-2">{appointment.customer_notes}</p>
                            </div>
                          )}
                          {appointment.service_notes && (
                            <div className="alert alert-success">
                              <strong><i className="icon-build"></i> Servis Notları:</strong>
                              <p className="mb-0 mt-2">{appointment.service_notes}</p>
                            </div>
                          )}
                          {appointment.rejection_reason && (
                            <div className="alert alert-danger">
                              <strong><i className="icon-close"></i> Red/İptal Nedeni:</strong>
                              <p className="mb-0 mt-2">{appointment.rejection_reason}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  getStatusColor = (status) => {
    const colorMap = {
      'pending': '#ff9800',
      'approved': '#4caf50',
      'rejected': '#f44336',
      'cancelled': '#9e9e9e',
      'completed': '#2196f3'
    };
    return colorMap[status] || '#9e9e9e';
  }

  getStatusColorDark = (status) => {
    const colorMap = {
      'pending': '#f57c00',
      'approved': '#388e3c',
      'rejected': '#d32f2f',
      'cancelled': '#616161',
      'completed': '#1976d2'
    };
    return colorMap[status] || '#616161';
  }

  getStatusIcon = (status) => {
    const iconMap = {
      'pending': 'schedule',
      'approved': 'check_circle',
      'rejected': 'cancel',
      'cancelled': 'block',
      'completed': 'done_all'
    };
    return iconMap[status] || 'info';
  }

  getStatusText = (status) => {
    const textMap = {
      'pending': 'Beklemede',
      'approved': 'Onaylandı',
      'rejected': 'Reddedildi',
      'cancelled': 'İptal Edildi',
      'completed': 'Tamamlandı'
    };
    return textMap[status] || status;
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps)(AppointmentDetail)));

